import { IconButton, InputAdornment } from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import React, { FC, useCallback, useState } from 'react';
import { theme }                            from '../../../styles';
import { ITextInputProps, TextInput }       from './TextInput/TextInput';

export const PasswordInput: FC<ITextInputProps> = (props) => {
  const [ showPassword, setShowPassword ] = useState(false);

  const toggleShowPassword = useCallback(
    () => {
      setShowPassword(!showPassword);
    },
    [ showPassword ]
  );

  return (
    <TextInput
      {...props}
      ref={null}
      fullWidth
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={toggleShowPassword}
              onMouseDown={event => event.preventDefault()}
            >
              { showPassword
                ? <VisibilityOffOutlinedIcon htmlColor={theme.colors.grey} />
                : <VisibilityOutlinedIcon htmlColor={theme.colors.grey} /> }
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
